import React from 'react';
import { useNavigate } from 'react-router-dom';
import PoolHotspot from '../components/hotspots/PoolHotspot';
import ShippingHotspot from '../components/hotspots/ShippingHotspot';
import MarketHotspot from '../components/hotspots/MarketHotspot';
import LobbyHotspot from '../components/hotspots/LobbyHotspot';
import ValetHotspot from '../components/hotspots/ValetHotspot';
import GiftShopHotspot from '../components/hotspots/GiftShopHotspot';
import OfficeHotspot from '../components/hotspots/OfficeHotspot';
import GuestHotspot from '../components/hotspots/GuestHotspot';

function Hotel() {
  const navigate = useNavigate();

  return (
    <div className="page splash2 hotelPage">
      <div className="page-header">Hotel</div>
      <div className="text-blocks">
        <div className="std-text">
          Whether you offer guest rooms alone or are a multi-amenity resort with a restaurant, casino, bar, pool or more, your property is a unique operation that requires robust solutions supported by an experienced technology partner.
        </div>
        <div className="std-text">
          From reservations to front desk, housekeeping, point of sale and property management, Agilysys solutions have you covered.
        </div>
      </div>
      <div className="logo" onClick={() => navigate('/aboutus/agilysys')}>
        <img src="/assets/casino/Agilysys-Logo.svg" alt="Agilysys" style={{width:'100%',height:'auto'}} />
      </div>
      <div className="tap">
        <img src="/assets/casino/solutions/Green-Touch-Icon.gif" alt="" />
        <div className="tap-prompt">
          Tap on each section of the map{'\n'}To drill into the details
        </div>
      </div>
      <div className="hotel-map">
        <div className="pool">
          <PoolHotspot onClick={() => navigate('pool')} />
        </div>
        <div className="shipping">
          <ShippingHotspot onClick={() => navigate('shipping')} />
        </div>
        <div className="market">
          <MarketHotspot onClick={() => navigate('grab-n-go')} />
        </div>
        <div className="lobby">
          <LobbyHotspot onClick={() => navigate('lobby')} />
        </div>
        <div className="valet">
          <ValetHotspot onClick={() => navigate('valet')} />
        </div>
        <div className="gift">
          <GiftShopHotspot onClick={() => navigate('gifts')} />
        </div>
        <div className="office">
          <OfficeHotspot onClick={() => navigate('office')} />
        </div>
        <div className="guest">
          <GuestHotspot onClick={() => navigate('guest')} />
        </div>
      </div>
    </div>
  );
}

export default Hotel;
